"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionTools = exports.SESSION_DURATION_MILLISECONDS = exports.SESSION_DURATION_MINUTES = exports.SESSION_LAST_ACTIVITY_TIME_KEY = exports.SESSION_ID_KEY = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const uuid_1 = require("uuid");
exports.SESSION_ID_KEY = 'sessionId';
exports.SESSION_LAST_ACTIVITY_TIME_KEY = 'sessionExpiration';
exports.SESSION_DURATION_MINUTES = 30;
exports.SESSION_DURATION_MILLISECONDS = exports.SESSION_DURATION_MINUTES * 60 * 1000;
const getLastUsedSessionId = async () => {
    const sessionId = await async_storage_1.default.getItem(exports.SESSION_ID_KEY);
    return sessionId;
};
/**
 * Function used to fetch the session id from AsyncStorage.
 * If a session doesn't exist yet, it will create a new one.
 * If a session exists but is expired (more than 30 minutes since last recorded activity),
 * it will refresh the session and return the new session id.
 * @param onSessionCreate optional param - function to be called when a new session is created.
 * @returns Promise<string> - sessionId
 */
const getOrUpdateSessionId = async (onSessionCreate) => {
    const value = await getLastUsedSessionId();
    if (!!value) {
        const isExpired = await isSessionExpired();
        return isExpired ? await createSessionId(onSessionCreate) : value;
    }
    const newSessionId = await createSessionId(onSessionCreate);
    return newSessionId;
};
/**
 * Function used to record activity in order to keep the current session alive. Calls the getOrUpdateSessionId
 * function before recording activity to ensure the session is up to date.
 * @param onSessionCreate optional param - function to be called when a new session is created.
 * @returns Promise<number> - the time in milliseconds of the newly recorded activity.
 */
const recordActivity = async (onSessionCreate) => {
    // update the sessionId, if needed, before recording activity
    await getOrUpdateSessionId(onSessionCreate);
    const now = Date.now();
    await async_storage_1.default.setItem(exports.SESSION_LAST_ACTIVITY_TIME_KEY, now.toString());
    return now;
};
/**
 *
 * @returns the time in milliseconds of the last recorded activity for the current session. Will not
 * update the current session or last recorded activity time.
 */
const getLastActivity = async () => {
    const time = await async_storage_1.default.getItem(exports.SESSION_LAST_ACTIVITY_TIME_KEY);
    if (!!time) {
        return +time;
    }
    return null;
};
const isSessionExpired = async () => {
    const lastActivity = await getLastActivity();
    if (!!lastActivity) {
        const currentTime = Date.now();
        const timeSinceLastActivityMS = currentTime - lastActivity;
        return timeSinceLastActivityMS > exports.SESSION_DURATION_MILLISECONDS;
    }
    return true;
};
const createSessionId = async (onSessionCreate) => {
    const sessionId = (0, uuid_1.v4)();
    await async_storage_1.default.multiSet([
        [exports.SESSION_ID_KEY, sessionId],
        [exports.SESSION_LAST_ACTIVITY_TIME_KEY, Date.now().toString()],
    ]);
    onSessionCreate?.();
    return sessionId;
};
exports.sessionTools = {
    getOrUpdateSessionId,
    recordActivity,
    getLastActivity,
};
